import dayjs from 'dayjs';

export function getCurrentTimestamp() {
  return dayjs().toISOString();
}

export function hasDaysElapsed(dateIso: string | undefined, days: number) {
  if (!dateIso) return false;

  const date = dayjs(dateIso);
  if (!date.isValid()) return false;

  return dayjs().diff(date, 'day') >= days;
}

export function getLatestCompletedAt(completedAtDates: Array<string | undefined>) {
  const validDates = completedAtDates.filter((date) => date && dayjs(date).isValid()) as string[];

  if (validDates.length === 0) return undefined;

  return validDates.reduce((latest, current) => {
    return dayjs(current).isAfter(dayjs(latest)) ? current : latest;
  });
}
